import React from "react";

export default function EmptyState({ title, description, action }) {
  return (
    <div className="text-center py-16 px-4 border border-dashed border-slate-200 rounded-xl bg-white">
      <div className="font-semibold text-slate-900">{title}</div>
      {description && <p className="mt-1 text-sm text-slate-500 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
